// This function is used to extract the contents of richTextInput in a way that preserves html tags
export function extractRichTextContentWithHtmlTags(contentContainer) {
    if (!contentContainer) {
        return '';
    }
    // By default the editor will escape html tags, so we need to unescape them in order to display them correctly in the preview and in the messenger
    const unescapedHtml = contentContainer.innerHTML
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>');
    return unescapedHtml;
}
